import { FileModel, RequestedFile } from 'api';

export type FileToUpload = {
  tmpId: string;
  name: string;
  file: File;
};

export type RequestedFileFulfillmentStatus =
  | 'pending'
  | 'uploaded'
  | 'not_applicable'
  | 'not_available';

// The generated client types fulfillment as an enum (and `is_fulfilled` as a
// string); the app keeps the string-union form used across request UIs.
export interface RequestedFileExtended
  extends Omit<RequestedFile, 'files' | 'fulfillment_status' | 'is_fulfilled'> {
  id?: number;
  tmpId: string;
  file: File;
  files?: Array<FileModel>;
  fileToUpload?: FileToUpload;
  name: string;
  fulfillment_status?: RequestedFileFulfillmentStatus;
  fulfillment_note?: string | null;
  is_fulfilled?: boolean;
}

export const isRequestedFileFulfilled = (file: {
  is_uploaded?: boolean;
  is_fulfilled?: boolean | string;
  fulfillment_status?: RequestedFileFulfillmentStatus | RequestedFile.fulfillment_status;
  files?: Array<FileModel>;
}): boolean => {
  const isFulfilled = file.is_fulfilled;
  const isNAStatus = file.fulfillment_status === 'not_applicable' || file.fulfillment_status === 'not_available';
  const isUploaded = file.is_uploaded;

  const fileIsComplete = isFulfilled || isNAStatus || isUploaded;

  if (fileIsComplete) {
    return true;
  }

  const hasFiles = Boolean(file.files && file.files.length > 0);

  return hasFiles;
};
